<template>
  <v-card tile>
    <v-card-title>Podjetja</v-card-title>
    <v-card-text v-if="companies">
      <v-data-table
          :headers="headers"
          :items="companies.data"
          :page.sync="companies.current_page"
          :items-per-page="companies.per_page"
          :server-items-length="companies.total"
          :options.sync="tableOptions"
          :search="search"
          :footer-props="{
          itemsPerPageOptions: [10, 25, 50],
        }"
          sort-by="id"
          class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field
                v-model="search"
                @change="updateFilters"
                append-icon="mdi-magnify"
                label="Iskalnik"
                single-line
                hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark class="mb-2" @click="create"
            >Dodaj
            </v-btn
            >
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <TooltipIconButton
              tooltip="Uredi"
              icon="mdi-pencil"
              @click="$router.push({ name: 'Company', params: { id: item.id } })"
          ></TooltipIconButton>
          <TooltipIconButton
              tooltip="Dokumenti"
              icon="mdi-file-document"
              @click="
              $router.push({
                name: 'CompanyDocuments',
                params: { companyId: item.id },
              })
            "
          ></TooltipIconButton>
          <TooltipIconButton
              tooltip="Izbriši"
              icon="mdi-delete"
              @click="remove(item)"
          ></TooltipIconButton>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="loadCompanies">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import TooltipIconButton from "@/components/TooltipIconButton.vue";

export default {
  components: {TooltipIconButton},
  data: () => ({
    dialog: false,
    headers: [
      {
        text: "ID",
        align: "start",
        value: "id",
      },
      {text: "Naziv", value: "title"},
      {text: "", value: "actions", sortable: false},
    ],
    companies: null,
    editedIndex: -1,
    editedItem: {},
    search: "",
  }),
  mounted() {
    this.search = this.$route.query.search || "";
  },
  methods: {
    loadCompanies() {
      let orderBy = {};
      if (
          this.tableOptions.sortBy.length > 0 &&
          this.tableOptions.sortDesc.length > 0
      ) {
        orderBy[this.tableOptions.sortBy[0]] =
            this.tableOptions.sortDesc[0] === true ? "desc" : "asc";
      }
      let params = {
        page: this.tableOptions.page,
        perPage: this.tableOptions.itemsPerPage,
        orderBy,
      };

      if (this.$route.query.search) {
        params["filters"] = {
          title: encodeURI("%" + this.$route.query.search + "%"),
        };
      }

      this.$http.get("api/v1/companies", {params}).then((response) => {
        this.companies = response.data;
      });
    },
    create() {
      this.$swal({
        title: "Dodaj podjetje",
        text: "Vpišite naziv podjetja",
        confirmButtonText: "Dodaj",
        cancelButtonText: "Prekliči",
        showCancelButton: true,
        input: "text",
      }).then((value) => {
        if (!value.value) {
          return;
        }
        this.$http
            .post("api/v1/companies", {title: value.value})
            .then((response) => {
              this.$router.push({
                name: "Company",
                params: {id: response.data.id},
              });
            });
      });
    },
    remove(item) {
      this.$swal({
        title: "Pozor",
        text: "Ali ste prepričani da želite izbrisati podjetje " + item.title,
        type: "warning",
        confirmButtonText: "Izbriši",
        cancelButtonText: "Prekliči",
        showCancelButton: true,
      }).then((value) => {
        if (value.value !== true) {
          return;
        }
        this.$http.delete("api/v1/companies/" + item.id).then(() => {
          this.loadCompanies();
        });
      });
    },
    updateFilters() {
      let query = {...this.$route.query};
      query['page'] = 1;
      delete query['search'];
      if (this.search.length > 0) {
        query['search'] = this.search;
      }
      this.$router.replace({
        query,
      }).catch(() => {
      });
      this.loadCompanies();
    }
  },
  computed: {
    tableOptions: {
      get() {
        return {
          page: parseInt(this.$route.query.page) || 1,
          itemsPerPage: parseInt(this.$route.query.perPage) || 10,
          sortBy: this.$route.query.sortBy ? [this.$route.query.sortBy] : [],
          sortDesc: [this.$route.query.sortDesc === 'true'],
        }
      },
      set(value) {
        let query = {
          page: value.page,
          perPage: value.itemsPerPage,
        };
        if (this.$route.query.search) {
          query["search"] = this.$route.query.search;
        }
        if (value.sortBy.length > 0) {
          query.sortBy = value.sortBy[0];
          query.sortDesc = value.sortDesc[0];
        }
        this.$router.replace({
          query,
        }).catch(() => {
        });
      },
    },
  },
  watch: {
    tableOptions: {
      handler(newValue, oldValue) {
        if(JSON.stringify(newValue) === JSON.stringify(oldValue)){
          return;
        }
        this.loadCompanies();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style></style>
